import { Skeleton } from '@mui/material';
import AboutSection from '../../components/Site/AboutSection';
import EmphasisMediasSectionLoading from '../../components/Site/EmphasisMediasSectionLoading';

const ShowroomStorefrontLoading = () => (
  <>
    <Skeleton variant="rectangular" width="100%" height={150} />
    <AboutSection loading aboutInfo={{}} />
    <EmphasisMediasSectionLoading />
    <EmphasisMediasSectionLoading loadingCardsProps={{ aspectRatio: 2.5 }} />
  </>
);

export default ShowroomStorefrontLoading;
